export default "__VITE_ASSET__DfhTDK3L__"